import React from 'react';
import { Grid } from '@mui/material';

import { useFormState } from 'shared/hooks';
import useConsultData from 'features/consults/hooks/useConsultData';
import useConsultInitialFormState from 'features/consults/hooks/useConsultInitialFormState';

import QuestionsPanel from 'features/consults/components/tabFields/QuestionsPanel';
import { CONSULT_TABS } from 'features/consults/utils/constants';
import schema from './validationSchema';
import { leftPanel, rightPanel } from './data';

const HPI = () => {
  const { register, control, getValues, setFormValues, getFieldError } =
    useFormState(schema, { stateSlice: 'consults', showAsSnackbar: true });
  const { consult, consultTabData, isEditable, handleFieldChange } =
    useConsultData(CONSULT_TABS.HPI, getValues);

  useConsultInitialFormState(consult.id, consultTabData, setFormValues);

  return (
    <Grid container spacing={6}>
      <Grid item sm={12} lg={6}>
        <QuestionsPanel
          {...leftPanel}
          control={control}
          register={register}
          onChange={handleFieldChange}
          getFieldError={getFieldError}
          disabled={!isEditable}
        />
      </Grid>
      <Grid item sm={12} lg={6}>
        <QuestionsPanel
          {...rightPanel}
          control={control}
          register={register}
          onChange={handleFieldChange}
          getFieldError={getFieldError}
          disabled={!isEditable}
        />
      </Grid>
    </Grid>
  );
};

export default HPI;
